<template>
    <div class="d-flex">
      <v-button :run="visualizar" :button="false" class="icon ml-3" title="Visualizar Firma">
        <i class="fal fa-external-link-alt"></i>
      </v-button>
      <v-button :run="imprimir" :button="false" class="icon ml-3" title="Imprimir Firma">
        <i class="fal fa-print"></i>
      </v-button>
    </div>
</template>

<script>
import FrontBusiness from "@/business/FrontBusiness";
import RelatorioBusiness from "@/business/RelatorioBusiness";
import LayoutImpressaoBusiness from "@/business/crud/LayoutImpressaoBusiness";

export default {

  name: "FirmaBotoes",
  components: {},
  props: {
    versaoId: String,
    servicoId: String
  },

  methods: {
    async visualizar() {
      if (!FrontBusiness.checkRequiredPermission(this.$root, 'PERMITIR_GERAR_CODIGO_FIRMA', 'Permissão requerida não encontrada: Permitir gerar código de firma')) return;
      try {
        const url = LayoutImpressaoBusiness.imprimirFirmaURL({versaoId: this.versaoId, servicoId: this.servicoId});
        await RelatorioBusiness.visualizarPdf(url, 'firma');
      } catch (e) {
        FrontBusiness.showError('', e.message);
      }
    },

    async imprimir(){
      if (!FrontBusiness.checkRequiredPermission(this.$root, 'PERMITIR_GERAR_CODIGO_FIRMA', 'Permissão requerida não encontrada: Permitir gerar código de firma')) return;
      try {
        await LayoutImpressaoBusiness.imprimirFirma({versaoId: this.versaoId, servicoId: this.servicoId})
      } catch (e) {
        FrontBusiness.showError('', e.message);
      }
    },
  }
}
</script>
